import { Typography } from "@mui/material";
import { Indicator, IndicatorSelection, LayerProperties } from "../../types";
import { OpacitySlider } from "./OpacitySlider";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
  indicator: Indicator;
  selection: IndicatorSelection;
  onOpacityChange: (value: number) => void;
}

export function LayerItemDetails(props: Props) {
  const { config, layerProperties } = props;

  return render();

  function render() {
    if (!props.indicator) return null;

    return (
      <>
        <OpacitySlider
          key={props.indicator.id}
          layerProperties={layerProperties}
          value={props.selection.opacity}
          config={config}
          className="layerInfoItem"
          onChange={props.onOpacityChange}
        />

        {props.indicator.information.map((info, i) => (
          <div key={`${info.label}-${i}`} className="layerInfoItem">
            <Typography
              component="label"
              variant="subtitle2"
              fontSize="small"
              className="label"
            >
              {info.label}
            </Typography>
            <Typography
              component="p"
              variant="body1"
              className="value"
              gutterBottom
            >
              {info.value}
            </Typography>
          </div>
        ))}
      </>
    );
  }
}
